import { createSelector } from 'reselect';

export const selectedDocuments = (state: any) => {
  return state.get('documents');
};

const makeSelectDocument = () =>
  createSelector(selectedDocuments, document => {
    if (document && document.get('uploadedDocument')) {
      return document.get('uploadedDocument').toJS();
    }
    return {};
  });

const makeSelectDocumentId = () =>
  createSelector(selectedDocuments, document => {
    if (document && document.get('documentId')) {
      return document.get('documentId');
    }
    return '';
  });

export { makeSelectDocument, makeSelectDocumentId };
